export default __webpack_public_path__ + "static/media/handKalenday.65d79d68.png";